const TextoOpcionalONull = (valor) => {
  if (valor === null || valor === undefined) {
    return null;
  }
  const texto = String(valor).trim();
  return texto === '' ? null : texto;
};

export const PaisVacio = () => {
  return {
    id: null,
    nombre: '',
    idConfederacion: null,
    nombreDivisiones: '',
  };
};

export const ProvinciaVacia = (idPais) => {
  return {
    id: null,
    nombre: '',
    nombreIdiomaOriginal: '',
    idPais: idPais,
  };
};

export const LocalidadVacia = (idPais, idProvincia) => {
  return {
    id: null,
    nombre: '',
    nombreIdiomaOriginal: '',
    nombreAlternativo: '',
    idPais: idPais,
    idProvincia: idProvincia,
  };
};

export const SavePais = (pais) => {
  return {
    nombre: pais.nombre,
    idConfederacion: pais.confederacion === null ? null : pais.confederacion.id,
    nombreDivisiones: pais.nombreDivisiones,
  };
};

export const SaveProvincia = (provincia) => {
  return {
    nombre: provincia.nombre,
    nombreIdiomaOriginal: TextoOpcionalONull(provincia.nombreIdiomaOriginal),
    idPais: provincia.idPais,
  };
};

export const SaveLocalidad = (localidad) => {
  return {
    idPais: localidad.idPais,
    idProvincia: localidad.idProvincia,
    nombre: localidad.nombre,
    nombreIdiomaOriginal: TextoOpcionalONull(localidad.nombreIdiomaOriginal),
    nombreAlternativo: TextoOpcionalONull(localidad.nombreAlternativo),
  };
};
